<template>
  <div class="tg_page">
    <!-- 轮播图 -->
    <div class="swipe">
      <van-swipe
        :autoplay="3000"
        indicator-color="linear-gradient(to right,#ffeb78,#fe6392)"
        class="vant_swper"
      >
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img v-lazy="image" :src="image" @click="gozblist" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 标题 -->
    <div class="tg_title">
      <div
        class="tg_title01"
        v-for="(item, index) in imgs"
        :key="index"
        @click="tabs(index, item)"
      >
        <img :src="item" />
      </div>
    </div>
    <!-- 小标题 -->
    <div class="tg_xbt">优+投顾服务--{{ title }}</div>
    <div class="tg_content" ref="box">
      <van-swipe
        :loop="false"
        indicator-color="linear-gradient(to right,#ffeb78,#fe6392)"
        ref="swipe"
        @change="tabs"
        :style="{ height: styleheight + 'rem' }"
      >
        <van-swipe-item
          v-for="(item, index) in fundsList"
          :key="'ids_' + index"
          class="tg_contents"
        >
          <div :ref="'box_' + index">
            <tr v-for="(it, index) in item" :key="'ids2_' + index">
              <!-- 上半部 -->
              <div class="tg_contenttop">
                <div class="tg_contenttopleft">
                  <!-- <image :src="item.url"> -->
                  <img :src="it.url" alt="" />
                </div>
                <div class="tg_contenttopright">
                  <div class="tg_righttitle">{{ it.rq }}</div>
                  <div class="tg_righttitlename">{{ it.name }}</div>
                  <p class="tg_righttitletontent">
                    {{ it.title }}
                  </p>
                  <p class="tg_righttitletontent tg_righttitletontents">
                    {{ it.title1 }}
                  </p>
                </div>
              </div>
              <div class="gtrw">
                <div class="gtrw_left">
                  <div class="left_icon"></div>
                  <div class="left_name">{{ it.zj }}</div>
                </div>
                <div class="gtrw_rifgt" @click="godsf(it)"></div>
              </div>
              <div class="tg_gg" v-if="it.zj == '葛智炜'" @click="cs(1)">站在主力角度思考，知己知彼百战不殆</div>
              <div class="tg_gg" v-if="it.zj == '赵冬梅'" @click="cs(2)" style="line-height:.8rem;">股市赛道，是提升对自我的认知</div>
              <div class="tg_gg" v-if="it.zj == '马明虎'" @click="cs(3)" style="line-height:.8rem;">股市懂得逻辑，方可制胜</div>
              <div class="tg_gg" v-if="it.zj == '林东川'" @click="cs(4)" style="line-height:.8rem;">把握关键时机，成就极致猎手</div>
              <div class="tg_gg" v-if="it.zj == '李胜国'" @click="cs(5)">不论是止盈还是止损，都要感谢机会</div>
              <div class="tg_gg" v-if="it.zj == '刘苏铭'" @click="cs(6)" style="line-height:.8rem;">时间窗口中捕捉潜伏机会</div>
              <div class="tg_gg" v-if="it.zj == '唐小强'" @click="cs(7)">掌握板块轮动的脉搏，就能把握住市场的节奏</div>
              <div class="tg_gg" v-if="it.zj == '李培华'" @click="cs(8)">放弃一些机会，才能抓住一些机会</div>
              <div class="tg_gg" v-if="it.zj == '窦少杰'" @click="cs(9)" style="line-height:.8rem;">顺应市场，把握趋势</div>
              <div class="tg_gg" v-if="it.zj == '周亮'" @click="cs(10)">风险管理第一位，保住本金最重要</div>
              <div class="tg_gg" v-if="it.zj == '陈雷'" @click="cs(11)">行业的想象力是股票估值的天花板</div>
              <div class="tg_gg" v-if="it.zj == '张文君'" @click="cs(12)">坚持基本面右侧投资，趋势能够持续的个股</div>
              <div class="tg_gg" v-if="it.zj == '高寒'" @click="cs(13)" style="line-height:.8rem;">个股标的不是孤立存在的</div>
              <div class="tg_gg" v-if="it.zj == '赵冬'" @click="cs(14)">知识技术的作用是“3”，心态的作用是“7”</div>
              <div class="tg_gg" v-if="it.zj == '区浩强'" @click="cs(15)" style="line-height:.8rem;">趋势为王，严格止损</div>
              <div class="tg_gg" v-if="it.zj == '钟盛坚'" @click="cs(16)" style="line-height:.8rem;">永远与最靠谱的人并肩作战</div>
              <div class="tg_gg" v-if="it.zj == '罗伟伟'" @click="cs(17)">坚持深度学习，方能知己知彼，百战不殆</div>
              <div class="tg_gg" v-if="it.zj == '贺波强'" @click="cs(18)" style="line-height:.8rem;">资产配置是成功的关键性因素</div>
              <div class="tg_gg" v-if="it.zj == '吴珣'" @click="cs(19)" style="line-height:.8rem;">货悖而入，亦悖而出</div>
              <div class="tg_gg" v-if="it.zj == '赵鹏'" @click="cs(20)">可以走上投机的道路，但须根绝投机的心理</div>
              <div class="tg_gg" v-if="it.zj == '郭忠明'" @click="cs(21)">投资是一场修行，自己才是最大的敌人</div>
              <div class="tg_gg" v-if="it.zj == '吴达耀'" @click="cs(22)">投资是认知的变现，机会来自深度研究</div>
              <div class="tg_gg" v-if="it.zj == '方雪松'" @click="cs(23)">股海淘金，选对股票操作方式很重要</div>
              <div class="tg_gg" v-if="it.zj == '王书红'" @click="cs(24)">投资需确定主导思路，围绕其思路再做完善</div>
              <div class="tg_gg" v-if="it.zj == '孔小东'" @click="cs(25)">要形成自己的交易模式，就得先找到投资的锚</div>
              <div class="tg_gg" v-if="it.zj == '孙舒锴'" @click="cs(26)">震荡市的任务是买筹码、牛市的任务才是赚钞票</div>
              <div class="tg_gg" v-if="it.zj == '黄鹏'" @click="cs(27)">做短线就是提高资金运作效率，无论盈亏，快速知晓</div>
            </tr>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { openService } from "@/utils/common";
import {
  pageBuryingPoint,
  eventBuryingPoint,
  DestructyBuryingPoint,
} from "@/utils/BuryingPoint";
import { showToast, pageRecord, setHtmlTitle } from "@/utils/h5";

export default {
  name: "rule",
  data() {
    return {
      current: 0, //自定义指示点
      list: [],
      type: 0,
      flag: false, //有无采访
      title: "锦囊",
      images: [
        require("../assets/img/tg_swper01.png"),
        require("../assets/img/tg_swper02.png"),
        require("../assets/img/tg_swper03.png"),
      ], //轮播图
      //标题图
      imgs: [
        require("../assets/img/tg_cl.png"),
        require("../assets/img/tg_cl02.png"),
        require("../assets/img/tg_cl03.png"),
      ],
      //数组
      fundsList: [
        [
          {
            type: 0,
            name: "泽金看投资",
            title: "618期间销量第一！图文直播+签约视频直播:",
            title1: "知己知彼，站在主力的思维认识如何割韭菜",
            zj: "葛智炜",
            rq: "人气产品",
            text: "站在主力角度思考，知己知彼百战不殆",
            url: require("../assets/img/tg_01 (1).jpg"),
          },
          {
            type: 0,
            name: "泽金妙计",
            title: "618期间销量前三！三个月胜率稳定70%+！",
            title1: "818签约即可获赠老师老师专题直播课",
            zj: "赵冬梅",
            rq: "推荐产品",
            text: "股市赛道，是提升对自我的认知",
            url: require("../assets/img/tg_01 (9).jpg"),
          },
          {
            type: 0,
            name: "泽金短线热点",
            title: "签约赠送A股训练营课程；互动问股",
            title1: "挖掘市场风口，研究创造价值，注重趋势交易",
            rq: "人气产品",
            zj: "马明虎",
            text: "股市懂得逻辑，方可制胜",
            url: require("../assets/img/tg_01 (6).jpg"),
          },

          {
            type: 0,
            name: "泽金金牛一号",
            title: "活动期间限时6折！签约/订阅即可享视频直播课程，",
            title1: "把握市场方向，精准狙击热点，",
            rq: "主理产品",
            zj: "李胜国",
            text: "不论是止盈还是止损，都要感谢机会",
            url: require("../assets/img/tg_01 (3).jpg"),
          },
          {
            type: 0,
            name: "泽金久运长虹",
            title:
              "签约即享：股票池+图文直播；不限于收评、热点等10项资讯解读服务；",
            title1: "周策略、月度策略；专享交流会",
            rq: "主理产品",
            zj: "刘苏铭",
            text: "时间窗口中捕捉潜伏机会",
            url: require("../assets/img/tg_01 (5).jpg"),
          },
          {
            type: 0,
            name: "泽金藏牛内参",
            title: "把握短期热点，捕捉政策动向，",
            title1: "受益行业趋势，深耕基本面",
            rq: "锦囊新秀",
            zj: "唐小强",
            url: require("../assets/img/tg_01 (8).jpg"),
          },
          {
            type: 0,
            name: "泽金中短线",
            title: "宏观经济分析实战化应用",
            title1: "",
            rq: "主理产品",
            zj: "李培华",
            url: require("../assets/img/tg_01 (2).jpg"),
          },
          {
            type: 0,
            name: "泽金趋势中短战",
            title: "优选业绩突出、有发展前景、且技术面横盘突破的个股进行操作。",
            title1: "",
            rq: "主理产品",
            zj: "窦少杰",
            url: require("../assets/img/tg_01 (11).jpg"),
          },
          {
            type: 0,
            name: "泽金湾区之光",
            title:
              "市场热点+个股技术面+个股基本面三大维度的相互结合，为资产增收益！",
            title1: "",
            rq: "主理产品",
            zj: "苏焕婷",
            url: require("../assets/img/tg_01 (7).jpg"),
          },
          {
            type: 0,
            name: "泽金迎客松",
            title: "精研宏观及盘面热点，跟踪资金流向，精选个股；",
            title1: "逻辑清晰、观点明确、节奏适中、轻松跟随。",
            rq: "主理产品",
            zj: "周亮",
            url: require("../assets/img/tg_01 (10).jpg"),
          },
        ],
        ///

        //////
        [
          {
            type: 1,
            name: "泽元聚金",
            title: "以预期、边际、交易思维分析,注重逻辑自洽",
            title1: "",
            rq: "主理产品",
            zj: "吴达耀",
            url: require("../assets/img/tg_03 (6).jpg"),
          },
          {
            type: 1,
            name: "泽元金手指",
            title: "超短线高频交易；",
            title1: "波浪理论，精研热点，挖掘连班龙头后的接力和二波行情",
            rq: "人气产品",
            zj: "黄鹏",
            url: require("../assets/img/tg_03 (1).jpg"),
          },
          {
            type: 1,
            name: "泽元江南睿智",
            title: "图文直播+签约视频直播；",
            title1: "中短线选股择时+仓位管理；",
            rq: "人气产品",
            zj: "钟盛坚",
            url: require("../assets/img/tg_03 (7).jpg"),
          },

          {
            type: 1,
            name: "泽元慧通",
            title: "中长线+短线，行业选择，定位个股强弱；",
            title1: "",
            rq: "人气产品",
            zj: "方雪松",
            url: require("../assets/img/tg_03 (8).jpg"),
          },
          {
            type: 1,
            name: "泽元长安1号",
            title: "选股择时+个股持续跟踪；",
            title1: "洞悉主力操作，主中长期布局，短线热点为辅",
            rq: "主理产品",
            zj: "王书红",
            url: require("../assets/img/wangshuhong.jpg"),
          },
          {
            type: 1,
            name: "泽元波段操作",
            title: "引力理论”，“315战法”，自上而下，技术分析，低位黑马股",
            title1: "",
            rq: "主理产品",
            zj: "孔小东",
            url: require("../assets/img/tg_03 (2).jpg"),
          },
          {
            type: 1,
            name: "泽元抄底逃顶",
            title: "擅长选择低位基本面和技术面俱佳的个股，波段操作",
            title1: "",
            rq: "主理产品",
            zj: "孙舒锴",
            url: require("../assets/img/sxk.jpg"),
          },
          {
            type: 1,
            name: "汇元融通1号",
            title: "基本面分析、财务分析、中长期投资",
            title1: "",
            rq: "主理产品",
            zj: "汪红",
            url: require("../assets/img/wanghong.jpg"),
          },
        ],
        //
        [
          {
            type: 2,
            name: "先机赢·顺势先锋",
            title: "赢系列签约量第一！签约专享视频直播；",
            title1: "中线和短线强势跟踪，去弱留强，独创乘风擒龙战法",
            rq: "人气产品",
            zj: "钟盛坚",
            url: require("../assets/img/tg_02 (12).jpg"),
          },
          {
            type: 2,
            name: "赢先机·突破策略",
            title: "618签约量前三！签约专享视频直播，",
            title1: "推理行为逻辑，剖析投资心理，基本面结合技术指标选股",
            rq: "人气产品",
            zj: "李桂斌",
            url: require("../assets/img/tg_02 (4).jpg"),
          },
          {
            type: 2,
            name: "赢先机·主线题材",
            title: "短中灵活轮动，中线行业趋势，短线事件驱动",
            title1: "",
            rq: "主理产品",
            zj: "赵冬梅",
            url: require("../assets/img/tg_02 (10).jpg"),
          },
          {
            type: 1,
            name: "赢先机·共振选股策略",
            title: "近三个月胜率90%以上！",
            title1: "以预期、边际、交易思维分析，注重逻辑自洽",
            rq: "人气产品",
            zj: "吴达耀",
            url: require("../assets/img/tg_03 (6).jpg"),
          },
          {
            type: 2,
            name: "先机赢·大势所趋",
            title:
              "近三个月胜率75%以上！独创《极致战法》签约赠送12节视频课程；",
            title1: "量+价+时空，三维交易体系",
            rq: "人气产品",
            zj: "林东川",
            url: require("../assets/img/tg_01 (4).jpg"),
          },
          {
            type: 2,
            name: "先机赢·洞悉主力",
            title: "宏观经济分析实战化应用",
            title1: "",
            rq: "主理产品",
            zj: "李培华",
            url: require("../assets/img/tg_01 (2).jpg"),
          },
          {
            type: 2,
            name: "先机赢·量化优选策略",
            title: "量化分析公式选股，波浪结合周期理论剖析大盘；",
            title1: "",
            rq: "赢系列新秀",
            zj: "赵鹏",
            url: require("../assets/img/tg_02 (11).jpg"),
          },
          {
            type: 2,
            name: "赢先机·风林火山",
            title: "实时市场解读，交易理念、交易策略分析；",
            title1: "",
            rq: "赢系列新秀",
            zj: "郭忠明",
            url: require("../assets/img/tg_02 (1).jpg"),
          },
          {
            type: 2,
            name: "先机赢·智慧掘金",
            title: "签约可享技术分析五大战法课程；股票池+双掘金战法投研体系；",
            title1: "每周两场视频直播；盘中互动优先解答",
            rq: "主理产品",
            zj: "高寒",
            url: require("../assets/img/tg_02 (14).jpg"),
          },
          {
            type: 2,
            name: "赢先机·景气赛道策略",
            title: "研究机构思路，跟踪机构持仓，把握机构动向",
            title1: "",
            rq: "主理产品",
            zj: "罗伟伟",
            url: require("../assets/img/tg_02 (5).jpg"),
          },
          {
            type: 2,
            name: "赢先机·明珠精选策略",
            title: "近三个月胜率75%+！热点追击，",
            title1: "价值趋势，中短线为主",
            rq: "赢系列新秀",
            zj: "张文君",
            url: require("../assets/img/tg_02 (8).jpg"),
          },
          {
            type: 2,
            name: "赢先机·霞举飞虹",
            title: "近三个月胜率75%+！高胜率右侧交易，",
            title1: "精研戴维斯双击；",
            rq: "赢系列新秀",
            zj: "陈雷",
            url: require("../assets/img/tg_02 (13).jpg"),
          },
          {
            type: 2,
            name: "赢先机·右侧先锋策略",
            title: "结合市场热点，趋势为先，",
            title1: "右侧介入，追求中短期收益",
            rq: "主理产品",
            zj: "胡春寿",
            url: require("../assets/img/tg_02 (3).jpg"),
          },

          {
            type: 2,
            name: "先机赢·凤凰涅槃",
            title: "近三个月胜率75%+！次新股掘金，",
            title1: "科创板掘金;",
            rq: "主理产品",
            zj: "赵冬",
            url: require("../assets/img/tg_02 (9).jpg"),
          },
          {
            type: 2,
            name: "赢先机·价值成长",
            title: "趋势为王，专注趋势初起，",
            title1: "挖掘质优个股",
            rq: "主理产品",
            zj: "区浩强",
            url: require("../assets/img/tg_02 (6).jpg"),
          },

          {
            type: 2,
            name: "赢先机·成长价值策略",
            title: "成长价值企业，财报分析，",
            title1: "行业景气度，技术面，多维度选股",
            rq: "主理产品",
            zj: "贺波强",
            url: require("../assets/img/tg_02 (2).jpg"),
          },
          {
            type: 2,
            name: "赢先机·价值领航",
            title: "结合中国传统文化的价值投资",
            title1: "",
            rq: "主理产品",
            zj: "吴珣",
            url: require("../assets/img/tg_02 (7).jpg"),
          },
        ],
      ],
      styleheight: 64.3,
    };
  },
  created() {
    setHtmlTitle("投顾分会场");
    // this.clientHeight = document.body.clientHeight - 110 - 120;
    pageBuryingPoint("p_ytwx818lcjtgzqss_01");
  },
  beforeDestroy() {
    //页面销毁前
    DestructyBuryingPoint("p_ytwx818lcjtgzqss_01");
  },

  methods: {
    //去直播页
    gozblist() {
      window.location.href = `https://saas0.yundzh.com/?r=472&source=shibaWx&yk=0#/gyzq/home`;

      // eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqba_01");
      // openService("BANNER", "3", "FN_SM_TGLive", param);
    },

    tabs(index) {
      this.$refs.swipe.swipeTo(index);
      this.$refs.box.scrollTop = 0;
      if (index == 0) {
        (this.styleheight = 64.3), (this.title = "锦囊");
      } else if (index == 1) {
        this.styleheight = 50;

        this.title = "组合";
      } else {
        this.styleheight = 110.5;
        this.title = "赢系列";
      }
    },
    godsf(item) {
      // console.log(item);
      if (item.zj == "葛智炜") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "142" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqba_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "赵冬梅") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "143" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbb_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "马明虎") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "140" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbc_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "林东川") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4500" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbe_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "李胜国") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "155" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbe_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "刘苏铭") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "157" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbf_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "张文君") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4907" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbg_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "陈雷") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4828" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbh_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "高寒") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4506" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbi_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "赵冬") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4508" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbj_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "区浩强") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4499" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbk_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "罗伟伟") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4646" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbr_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "贺波强") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4527" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbm_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "吴珣") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4666" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbn_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "赵冬梅") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4473" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbu_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "钟胜坚") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4510" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbv_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "吴达耀") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "729" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbw_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "钟盛坚") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "786" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbx_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "方雪松") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "913" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqby_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "汪红") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "788" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbz_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "王书红") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "783" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbaa_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "孔小东") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "794" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbab_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "唐小强") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "163" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbac_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "李培华") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "165" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbad_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "窦少杰") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "166" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbae_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "苏焕婷") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "167" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbaf_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "周亮") {
        let param = {
          webUrl: { startUPAdv: "2", funId: "2", tipsId: "170" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbag_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "赵鹏") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4947" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbah_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "郭忠明") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4925" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbaj_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "李桂斌") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4504" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbak_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "胡春寿") {
        let param = {
          webUrl: { startUPAdv: "15", funId: "1", productId: "4971" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbal_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "孙舒锴") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "795" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbaq_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      } else if (item.zj == "黄鹏") {
        let param = {
          webUrl: { startUPAdv: "8", funId: "0", portfolioId: "787" },
        };
        eventBuryingPoint("c_ytwxyx_01", "l_ytwxtgzqbaw_01");
        openService("BANNER", "3", "FN_SM_TGLive", param);
      }
    },
    cs(item) {
      if (item == 17) {
        window.location.href = `https://saas.yundzh.com/#/gyzq/liveBack/21277`;
      }else if(item == 7){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000159&skin=0&channel=gyzq`;
      }else if(item == 20){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000157&skin=0&channel=gyzq`;
      }else if(item == 20){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000157&skin=0&channel=gyzq`;
      }else if(item == 14){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000149&skin=0&channel=gyzq`;
      }else if(item == 23){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000153&skin=0&channel=gyzq`;
      }else if(item == 25){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000148&skin=0&channel=gyzq`;
      }else if(item == 26){
        window.location.href = `https://djyyzt.gyzq.com.cn:18080/news/detail?listType=2004&newsId=0-1000150&skin=0&channel=gyzq`;
      }
    },
  },
};
</script>

<style>
.van-swipe__indicators {
  top: 12px;
}
.van-swipe__indicator {
  background-color: red;
}
</style>
